export default [
    {
        path: '/ambiences/room-reservations',
        name: 'ambiences-room-reservations',
        component: () => import ('./views/RoomReservationIndex'),
        meta: {
            title: 'Reserva de Instalação',
            icon: 'mdi-calendar-clock',
            breadcrumbs: [
                { text: 'Totvs - Salas', disabled: true },
                { text: 'Reserva', disabled: true }
            ]
        }
    },
]
